module.exports = __webpack_public_path__ + "media/images/Reports-50d6fd1b7bc7059c926ba81a5d4b9af7.svg";